import { PulseEnvironment } from '../../globals';

export class Quote {
    constructor(private readonly env: PulseEnvironment) {}

    async quoteSize(): Promise<number | undefined | null> {
        try {
            if (typeof this.env.navigator?.storage?.estimate !== 'function') {
                return null;
            }

            const estimate = await this.env.navigator.storage.estimate();

            return estimate?.quota;
        } catch {
            return null;
        }
    }
}
